import { Component } from 'react';
import { MenuListProps as MuiMenuListProps } from '@material-ui/core';
import { WithStyles, withStyles } from '@material-ui/core/styles';
import { menuStyles } from './menuStyles';
import MuiMenu, { MenuProps as MuiMenuProps } from '@material-ui/core/Menu';

/**
 * A styled Menu component
 * @see {@link https://material-ui.com/api/menu/} Material API docs for props
 */

export interface MenuListProps extends MuiMenuListProps {
  component?: string;
}

export interface MenuProps extends MuiMenuProps {
  MenuListProps?: MenuListProps;
}

class MenuForExport extends Component<MenuProps & WithStyles<typeof menuStyles>> {
  render() {
    const { children, classes, MenuListProps = { component: 'div' }, ...rest } = this.props;
    const finalMenuListProps = {
      component: 'div',
      ...MenuListProps,
    };
    return (
      <MuiMenu classes={classes} MenuListProps={finalMenuListProps} {...rest}>
        {children}
      </MuiMenu>
    );
  }
}

const Menu = withStyles(menuStyles)(MenuForExport);

export default Menu;
